import { Component, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_LISTVIEW } from '@progress/kendo-angular-listview';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { FormInstanceDetailedDto, FormInstancesClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { DateTimezonePipe } from '@unity/pipes/date-timezone.pipe';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
import { SortConfig } from '@unity/utils/types';

@Component({
  selector: 'unity-grid-form-instance-shared',
  imports: [KENDO_GRID, KENDO_LISTVIEW, GridSharedComponent, DateTimezonePipe, LinkGridcellSharedComponent, TypedDirective],
  templateUrl: './grid-form-instance-shared.component.html',
  styleUrl: './grid-form-instance-shared.component.scss',
})
export class GridFormInstanceSharedComponent extends AbstractGridComponent<FormInstanceDetailedDto> {
  private readonly formInstancesClient = inject(FormInstancesClient);

  protected override readonly resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      const agreementId = this.$agreementId();
      const formScheduleId = this.$formScheduleId();
      return query && agreementId && formScheduleId ? { query, agreementId, formScheduleId } : undefined;
    },
    stream: ({ params: { agreementId, formScheduleId, query } }) => {
      return this.formInstancesClient.getAllForAgreementAsDetailed(
        agreementId,
        formScheduleId,
        query.page,
        query.pageSize,
        query.orderBy,
        query.filter
      );
    },
  });

  protected defaultSort: SortConfig[] = [
    {
      field: 'open_date',
      dir: 'asc',
    },
    {
      field: 'due_date',
      dir: 'asc',
    },
    {
      field: 'id',
      dir: 'asc',
    },
  ];

  public readonly $formScheduleId = input.required<number>({ alias: 'formScheduleId' });
  public readonly $agreementId = input.required<number>({ alias: 'agreementId' });
}
